import { SURVEY, SET_NAME, SET_QUESTION_ANSWER, OPEN_POPUP, GET_FAMILY_INDEX } from '@/store/actions/survey'
import { getTextByType, getFullTextByType } from '@/utils/survey'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(SURVEY, {
      getFamilyIdx: GET_FAMILY_INDEX,
    }),
  },
  methods: {
    getTextByType,
    getFullTextByType,
    getAttendantName(attendant) {
      if(attendant.type !== 'F') {
        return this.getFullTextByType(attendant);
      } else {
        return this.getTextByType(attendant) + (this.getFamilyIdx(attendant.type_seq) + 1);
      }
    },
    getPaymentMethodText(paymentMethod) {
      switch(paymentMethod.toLowerCase()) {
        case 'creditcard': return '신용카드';
        case 'banktransfer': return '계좌이체';
        default: return '기타';
      }
    },
    inputName(idx, name) {
      this.$store.commit(`${SURVEY}/${SET_NAME}`, { idx, name });
    },
    inputJuminNumber(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      const hasError = raw_data.length !== maxLength;
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    openPopupLayer(payload) {
      this.$store.dispatch(`${SURVEY}/${OPEN_POPUP}`, payload);
    },
  }
}


// WEBPACK FOOTER //
// ./src/views/survey2/mixins/CommonMethodMixin.js